import me from './me.png';

export const nav = [
  { key: 'about', label: 'About Me' },
  { key: 'experience', label: 'Work Experience' },
  { key: 'education', label: 'Education' },
  { key: 'blog', label: 'Blog' },
  { key: 'skills', label: 'Skills' },
  { key: 'contact', label: 'Contact Me' }
];

export const profile = {
  greeting: 'Hi',
  name: 'Harsh Srivastava',
  role: 'Software Engineer',
  summary:
    'crafting scalable distributed systems that power real-time business logic at massive scale.',
  location: 'Varanasi, India',
  avatar: me
};

export const experience = [
  {
    company: 'Livspace',
    role: 'Software Development Engineer',
    period: 'September 2024 — Present',
    items: [
      'Led the Development of LS-Homes Order Creation, Invoice, and Real-time Status Sync from scratch,implemented workflow automation with Svix Webhook and Temporal, supporting $450K+ annual order value.',
      'Developed a Reconciliation Job ensuring 99.99% data accuracy between the Order and Source Systems, resolving stale records, and eliminating fraudulent or inconsistent transactions.',
      'Migrated order, shipment, and item allocation synchronous processing events to Temporal Workflow, reducing processing time by 70%, failures by 80% and shipment delays from hours to minutes, boosting operations, customer experience, and enabling 3x holiday scaling with only a 15% infrastructure cost increase.'
    ],
    tech: ['Distributed Systems', 'Microservices', 'RESTful APIs', 'Java', 'SpringBoot', 'Golang', 'Node.js', 'Temporal', 'PostgreSQL']
  },
  {
    company: 'Signzy',
    role: 'Software Development Engineer',
    period: 'August 2023 — August 2024',
    items: [
      'Developed Aadhaar Masking Service processing 30k docs/day with 99.99% accuracy using event driven architecture, compliant with RBI norms',
      'Designed and owned customer verification system (PAN, Aadhaar, Basic Details) enabling concurrent validation and cutting verification time by 85%.',
      'Refactored legacy Java 8 code and migrated to Java LTS and Spring LTS versions, reducing latency by 40% and improving system performance.'
    ],
    tech: ['React', 'Node.js', 'TypeScript', 'Microservices', 'RESTful APIs', 'Golang', 'MYSQL']
  },
  {
    company: 'Uolo.com',
    role: 'SDE Intern',
    period: 'January 2023 — July 2023',
    items: [
      'Migrated WelcomeSMS from PHP to Node.js, achieving 70% latency reduction through asynchronous processing.',
      'Developed an service for real-time uploading of any document type to Google Drive, allowing schools to upload update, and manage access permissions (read/write) for users.'
    ],
    tech: ['React', 'Node.js', 'Express.js', 'MongoDB', 'Google Drive API']
  }
];

export const education = [
  {
    school: 'GL Bajaj Institute of Technology and Management',
    degree: 'B.Tech in Computer Science',
    period: '2019 — 2023',
    image:
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=800&q=60',
    items: ['Data Structures and Algorithms', 'Operating Systems', 'Distributed Systems', 'Database Management Systems', 'Computer Networks']
  }
];

export const blog = [
  {
    title: 'Recover Method in Spring Boot’s Retry Mechanism',
    link: 'https://medium.com/@harshsri875/recover-method-in-spring-boots-retry-mechanism-3e75a58a4688',
    excerpt:
      'Recover method in Spring Boot’s Retry Mechanism.'
  },
  {
    title: 'Svix Webhook: A Deep Dive into Event-Driven Architecture',
    link: 'https://medium.com/@harshsri875/svix-webhook-0069eff0782e',
    excerpt:
      'Svix Webhook: A Deep Dive into Event-Driven Architecture.'
  },
  {
    title: 'Reconciliation Job: Ensuring Data Accuracy in Distributed Systems',
    link: 'https://medium.com/@harshsri875/reconciliation-job-4309444b8af5',
    excerpt:
      'Reconciliation Job: Ensuring Data Accuracy in Distributed Systems.'
  }
];

export const skills = [
  {
    category: 'Frontend',
    items: ['React', 'TypeScript', 'Next.js', 'Redux', 'Tailwind CSS', 'HTML5/CSS3']
  },
  {
    category: 'Backend',
    items: ['Spring Boot', 'Temporal', 'Node.js', 'Golang', 'Express.js', 'REST API', 'Microservices', 'Kafka', 'GraphQL']
  },
  {
    category: 'Database',
    items: ['PostgreSQL', 'MongoDB', 'Redis', 'MySQL']
  },
  {
    category: 'Tools',
    items: ['LLM', 'Cursor', 'GitHub', 'Git', 'Docker', 'Jenkins', 'AWS', 'Grafana', 'Woodpecker']
  },
  {
    category: 'Languages',
    items: ['Java', 'C++', 'JavaScript', 'Python']
  }
];

export const contact = {
  email: 'code.harshsri@gmail.com',
  links: [
    { label: 'GitHub', href: 'https://github.com/harshsri28' },
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/harsh-sri-software-engineer/' },
    { label: 'Medium', href: 'https://medium.com/@harshsri875' },
    { label: 'LeetCode', href: 'https://leetcode.com/u/letsdoit26/' }
  ]
};

export const theme = {
  primary: '#4f46e5',
  primaryDark: '#3730a3',
  bg: '#f8fafc',
  surface: '#ffffff',
  text: '#0f172a',
  muted: '#64748b',
  sidebarBg: '#0f172a',
  sidebarText: '#e5e7eb'
};
